export const XS_MOBILE_MAX = 575;
export const MOBILE_MIN = XS_MOBILE_MAX + 1;
export const MOBILE_MAX = 767;
export const TABLET_PORTRAIT_MIN = MOBILE_MAX + 1;
export const TABLET_PORTRAIT_MAX = 991;
export const DESKTOP_TABLET_MIN = TABLET_PORTRAIT_MAX + 1;
export const TABLET_MAX = 1199;
export const DESKTOP_MIN = TABLET_MAX + 1;
export const SMALL_DESKTOP_MAX = 1600;
